/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    HasConvictionsLabel: {
        id: 'spm.components.convictionDetails.HasConvictionLabel',
        defaultMessage: 'Have {pronoun} had any motoring convictions or fixed penalty endorsements in the last 5 years?'
    },
    AddNewConvictionButtonLabel: {
        id: 'spm.components.convictionDetails.AddNewConvictionButtonLabel',
        defaultMessage: 'Add another conviction'
    },
    SaveConvictionButtonText: {
        id: 'spm.components.convictionDetails.SaveConvictionButtonText',
        defaultMessage: 'Save conviction'
    },
    ConvictionTypeLabel: {
        id: 'spm.components.convictionDetails.ConvictionTypeLabel',
        defaultMessage: 'Please select the closest description:'
    },
    ConvictionTypeSubLabel: {
        id: 'spm.components.convictionDetails.ConvictionTypeSubLabel',
        defaultMessage: 'Not all codes are listed - if the code ends 2, 4, or 6 please match to the equivalent code ending with a zero e.g. for SP32 select SP30.'
    },
    ConvictionDateLabel: {
        id: 'spm.components.convictionDetails.ConvictionDateLabel',
        defaultMessage: 'Please enter the date of the conviction:'
    },
    HasLicenseSuspendedLabel: {
        id: 'spm.components.convictionDetails.HasLicenseSuspendedLabel',
        defaultMessage: 'Were {pronoun} suspended from driving as a result of this conviction?'
    },
    MonthsOfSuspensionLabel: {
        id: 'spm.components.convictionDetails.MonthsOfSuspensionLabel',
        defaultMessage: 'How many months were {pronoun} suspended for?'
    },
    Suspended: {
        id: 'spm.components.convictionDetails.Suspended',
        defaultMessage: 'Suspended'
    },
    Cancel: {
        id: 'spm.components.convictionDetails.Cancel',
        defaultMessage: 'Cancel'
    },
    CommonClaims: {
        id: 'spm.components.convictionDetails.CommonConvictions',
        defaultMessage: '---- Common convictions ----'
    },
    AllClaims: {
        id: 'spm.components.convictionDetails.AllConvictions',
        defaultMessage: '---- All convictions ----'
    },
    PleaseSelect: {
        id: 'spm.components.convictionDetails.pleaseSelect',
        defaultMessage: 'Please select...'
    }
});
